import { call, put } from 'redux-saga/effects';

import { updateRegistration } from '@api/registrations';
import { registrationsDetailsSetModel } from '@models/Registrations';
import { history, jurisdictionsRoutes } from '@routes';
import { toastError, toastSuccess } from '@store/notifications';
import {
  registrationsInfoUpdateSuccessAction,
  registrationsInfoUpdateFailureAction,
} from '@store/registrations/registrationsDetail/registrationsInfo/registrationsInfo.actions';

import { registrationsInfoFetchSaga } from '../registrationsInfoFetchSaga';

export const registrationsInfoUpdateSaga = function* ({ payload }) {
  try {
    const response = yield call(updateRegistration, {
      data: registrationsDetailsSetModel({
        ...payload.data,
        entityId: payload.entityId,
      }),
      entityId: payload.entityId,
      regId: payload.regId,
    });

    yield call(registrationsInfoFetchSaga, { payload: { regId: response.id } }); // TODO: VFE-672 Remove when API response has been updated)

    yield put([
      registrationsInfoUpdateSuccessAction(),
      toastSuccess({
        message: {
          defaultMessage: 'Registration updated successfully.',
          id: 'pages.registrations.registration-info-update.notification.success',
        },
      }),
    ]);

    yield call(
      history.push,
      jurisdictionsRoutes.REG_DETAIL.make(response.entity, response.entityJurisdiction, response.id)
    );
  } catch (error) {
    const { fieldErrors, nonFieldErrors, hasNonFieldError, hasFieldError } = error.data || {};

    if (hasFieldError) {
      yield call(payload.setErrors, fieldErrors);
    }

    yield put(
      toastError({
        message: hasNonFieldError
          ? nonFieldErrors
          : {
              defaultMessage: 'Registration update failed.',
              id: 'pages.registrations.registration-info-update.notification.error',
            },
      })
    );

    yield put(registrationsInfoUpdateFailureAction());

    yield call(payload.setSubmitting, false);
  }
};
